import React, { Component } from 'react'
import axios from 'axios'
import { message, Switch, Checkbox } from 'antd'
import { connect } from 'react-redux'
import { ButtonItem } from '../../../../Components/Items'

const EVENTOS = [
  { key: 'tipoIncidenciaFaltaId', label: 'Tipo de incidencia para Falta' },
  { key: 'tipoIncidenciaRetardoId', label: 'Tipo de incidencia para Retardo', toggle: 'aplicarRetardos', toggleLabel: 'Aplicar retardos en la importación de nómina' },
  { key: 'tipoIncidenciaSalidaTempranaId', label: 'Tipo de incidencia para Salida Temprana', toggle: 'aplicarSalidasTempranas', toggleLabel: 'Aplicar salidas tempranas en la importación de nómina' },
  { key: 'tipoIncidenciaTiempoExtraId', label: 'Tipo de incidencia para Tiempo Extra', toggle: 'aplicarTiempoExtra', toggleLabel: 'Aplicar tiempo extra en la importación de nómina' },
]

// 'ninguno' sin días de la semana marcados es el comportamiento de antes: los días de descanso se
// importan como cualquier otro.
const MODOS_SEPTIMO = [
  { value: 'ninguno', label: 'Ninguno (sólo los días de la semana que marques abajo)' },
  { value: 'periodo', label: 'Los días 7º del periodo (columnas azules de la prenómina)' },
  { value: 'turno', label: 'Los días sin horario en el turno del empleado' },
  { value: 'ambos', label: 'Ambos' },
]

// value = día de la semana como lo cuenta el backend (0 = domingo … 6 = sábado)
const DIAS_SEMANA = [
  { label: 'Dom', value: 0 }, { label: 'Lun', value: 1 }, { label: 'Mar', value: 2 },
  { label: 'Mié', value: 3 }, { label: 'Jue', value: 4 }, { label: 'Vie', value: 5 },
  { label: 'Sáb', value: 6 },
]

class ConfiguracionIncidenciasAsistencia extends Component {
  state = { loading: true, guardando: false, tiposIncidencias: [], mapeo: {} }

  componentDidMount() {
    this.cargar()
  }

  async cargar() {
    const { empresaId, headersToken } = this.props
    try {
      const [resTipos, resConfig] = await Promise.all([
        axios.post('tiposIncidencias/selectTodasTiposIncidencias', { empresaId }, { headers: headersToken }),
        axios.post('configuracionIncidenciasAsistencia/selectConfiguracionIncidenciasAsistencia', { empresaId }, { headers: headersToken }),
      ])
      this.setState({
        loading: false,
        tiposIncidencias: resTipos.data.success === 2 ? (resTipos.data.data || []) : [],
        mapeo: resConfig.data.success === 2 ? (resConfig.data.data || {}) : {},
      })
    } catch {
      message.error('Error al cargar la configuración')
      this.setState({ loading: false })
    }
  }

  async guardar() {
    const { empresaId, headersToken } = this.props
    const { mapeo } = this.state
    this.setState({ guardando: true })
    try {
      const res = await axios.post(
        'configuracionIncidenciasAsistencia/editarConfiguracionIncidenciasAsistencia',
        {
          empresaId,
          tipoIncidenciaFaltaId: mapeo.tipoIncidenciaFaltaId || null,
          tipoIncidenciaRetardoId: mapeo.tipoIncidenciaRetardoId || null,
          tipoIncidenciaSalidaTempranaId: mapeo.tipoIncidenciaSalidaTempranaId || null,
          tipoIncidenciaTiempoExtraId: mapeo.tipoIncidenciaTiempoExtraId || null,
          aplicarRetardos: !!mapeo.aplicarRetardos,
          aplicarSalidasTempranas: !!mapeo.aplicarSalidasTempranas,
          aplicarTiempoExtra: !!mapeo.aplicarTiempoExtra,
          tipoIncidenciaSeptimoLaboradoId: mapeo.tipoIncidenciaSeptimoLaboradoId || null,
          tipoIncidenciaSeptimoLaboradoOtroDiaId: mapeo.tipoIncidenciaSeptimoLaboradoOtroDiaId || null,
          tipoIncidenciaSeptimoNoLaboradoId: mapeo.tipoIncidenciaSeptimoNoLaboradoId || null,
          septimoDiaModo: mapeo.septimoDiaModo || 'ninguno',
          septimoDiasSemana: mapeo.septimoDiasSemana || [],
        },
        { headers: headersToken }
      )
      if (res.data.success === 2) {
        message.success('Configuración guardada')
        this.setState({ mapeo: res.data.data })
      } else {
        message.error(res.data.message || 'No se pudo guardar la configuración')
      }
    } catch {
      message.error('Error al guardar la configuración')
    }
    this.setState({ guardando: false })
  }

  render() {
    const { loading, guardando, tiposIncidencias, mapeo } = this.state

    if (loading) {
      return <div style={{ padding: 40, textAlign: 'center', color: '#aaa' }}>Cargando…</div>
    }

    return (
      <div style={{ maxWidth: 520 }}>
        <p style={{ fontSize: 12, color: '#888' }}>
          Define a qué tipo de incidencia del catálogo corresponde cada evento que calcula
          el reloj checador. Esto se usa al importar incidencias de asistencia a la Pre-Nómina.
          Deja "— No importar —" para que ese evento nunca se importe.
        </p>

        {EVENTOS.map(({ key, label, toggle, toggleLabel }) => (
          <div key={key} style={{ marginBottom: 20 }}>
            <label style={{ display: 'block', marginBottom: 4, fontWeight: 500 }}>{label}</label>
            <select
              style={{ width: '100%', padding: 6 }}
              value={mapeo[key] || ''}
              onChange={(e) => this.setState({ mapeo: { ...mapeo, [key]: e.target.value || null } })}
            >
              <option value="">— No importar —</option>
              {tiposIncidencias.map((t) => (
                <option key={t._id} value={t._id}>{t.nombre} ({t.clave})</option>
              ))}
            </select>

            {toggle && (
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 8 }}>
                <Switch
                  size="small"
                  checked={!!mapeo[toggle]}
                  onChange={(checked) => this.setState({ mapeo: { ...mapeo, [toggle]: checked } })}
                />
                <span style={{ fontSize: 12, color: '#666' }}>{toggleLabel}</span>
              </div>
            )}
          </div>
        ))}

        <div style={{ marginBottom: 20, paddingTop: 12, borderTop: '1px solid #f0f0f0' }}>
          <label style={{ display: 'block', marginBottom: 4, fontWeight: 500 }}>Séptimo día</label>
          <p style={{ fontSize: 12, color: '#888', marginBottom: 8 }}>
            En los días de descanso no se importa falta, retardo, salida temprana ni tiempo extra:
            si el empleado checó se le pone el tipo de "laborado", y si no, el de "no laborado".
          </p>

          <label style={{ display: 'block', marginBottom: 4 }}>¿Qué días cuentan como séptimo día?</label>
          <select
            style={{ width: '100%', padding: 6, marginBottom: 12 }}
            value={mapeo.septimoDiaModo || 'ninguno'}
            onChange={(e) => this.setState({ mapeo: { ...mapeo, septimoDiaModo: e.target.value } })}
          >
            {MODOS_SEPTIMO.map(m => <option key={m.value} value={m.value}>{m.label}</option>)}
          </select>
          {(mapeo.septimoDiaModo === 'turno' || mapeo.septimoDiaModo === 'ambos') && (
            <p style={{ fontSize: 12, color: '#d46b08', marginTop: -6, marginBottom: 12 }}>
              Por turno, sólo es descanso el día que el turno deja sin horario. Si el turno tiene
              horario ese día, se importa como un día normal y la ausencia es falta; para esos
              turnos marca el día de descanso abajo.
            </p>
          )}

          <label style={{ display: 'block', marginBottom: 4 }}>
            Días de la semana que siempre son séptimo (para todos los empleados)
          </label>
          <Checkbox.Group
            options={DIAS_SEMANA}
            value={mapeo.septimoDiasSemana || []}
            onChange={(dias) => this.setState({ mapeo: { ...mapeo, septimoDiasSemana: dias } })}
          />
          <p style={{ fontSize: 12, color: '#888', marginTop: 4, marginBottom: 12 }}>
            Se suman a la opción de arriba, sin importar el turno ni el periodo.
          </p>

          <label style={{ display: 'block', marginBottom: 4 }}>Si asiste en su séptimo día (laborado)</label>
          <select
            style={{ width: '100%', padding: 6, marginBottom: 12 }}
            value={mapeo.tipoIncidenciaSeptimoLaboradoId || ''}
            onChange={(e) => this.setState({ mapeo: { ...mapeo, tipoIncidenciaSeptimoLaboradoId: e.target.value || null } })}
          >
            <option value="">— No poner nada —</option>
            {tiposIncidencias.map((t) => (
              <option key={t._id} value={t._id}>{t.nombre} ({t.clave})</option>
            ))}
          </select>

          <label style={{ display: 'block', marginBottom: 4 }}>Si el séptimo laborado no cae en domingo</label>
          <select
            style={{ width: '100%', padding: 6, marginBottom: 4 }}
            value={mapeo.tipoIncidenciaSeptimoLaboradoOtroDiaId || ''}
            onChange={(e) => this.setState({ mapeo: { ...mapeo, tipoIncidenciaSeptimoLaboradoOtroDiaId: e.target.value || null } })}
          >
            <option value="">— El mismo de arriba —</option>
            {tiposIncidencias.map((t) => (
              <option key={t._id} value={t._id}>{t.nombre} ({t.clave})</option>
            ))}
          </select>
          <p style={{ fontSize: 12, color: '#888', marginBottom: 12 }}>
            La prima dominical sólo aplica en domingo: aquí puedes poner, por ejemplo, días de
            descanso laborados.
          </p>

          <label style={{ display: 'block', marginBottom: 4 }}>Si no asiste en su séptimo día (no laborado)</label>
          <select
            style={{ width: '100%', padding: 6 }}
            value={mapeo.tipoIncidenciaSeptimoNoLaboradoId || ''}
            onChange={(e) => this.setState({ mapeo: { ...mapeo, tipoIncidenciaSeptimoNoLaboradoId: e.target.value || null } })}
          >
            <option value="">— No poner nada —</option>
            {tiposIncidencias.map((t) => (
              <option key={t._id} value={t._id}>{t.nombre} ({t.clave})</option>
            ))}
          </select>
        </div>

        <ButtonItem type="primary" loading={guardando} onClick={() => this.guardar()}>
          Guardar
        </ButtonItem>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  empresaId: state.empresa.id,
  headersToken: state.user.headersToken,
})

export default connect(mapStateToProps)(ConfiguracionIncidenciasAsistencia)
